import { Box, Button, Flex, Text } from "@chakra-ui/react"
import React from "react"

interface AppDialogProps {
  isOpen: boolean
  title: string
  confirmText?: string
  cancelText?: string
  width?: string
  onConfirm?: () => void
  onCancel?: () => void
}

export const AppDialog: React.FC<AppDialogProps> = (props) => {
  const {
    isOpen,
    title,
    confirmText = "确认",
    cancelText = "取消",
    width = "300px",
    onConfirm,
    onCancel,
  } = props
  return isOpen ? (
    <Flex
      id="full-screen-unvideo-element-tag" // 全屏模式下，虚拟鼠标事件系统识别 UI 元素的标记
      width="100vw"
      height="100vh"
      position="fixed"
      left={0}
      top={0}
      backgroundColor="rgba(0, 0, 0, 0.5)"
      justifyContent="center"
      alignItems="center"
      zIndex={9999}
    >
      <Flex
        id="full-screen-unvideo-element-tag" // 全屏模式下，虚拟鼠标事件系统识别 UI 元素的标记
        direction="column"
        align="center"
        width={width}
        backgroundColor="rgba(48, 49, 60, 1)"
        borderRadius="12px"
        overflow={"hidden"}
      >
        <Flex justify="center" align="center" fontSize="15px" minH="120px">
          <Text
            color="white"
            whiteSpace="pre-line"
            textAlign="center"
            px="18px"
          >
            {title}
          </Text>
        </Flex>
        <Flex
          width="100%"
          height="46px"
          borderTop="1px solid rgba(255, 255, 255, 0.1)"
        >
          <Button
            flex={1}
            height="100%"
            variant="ghost"
            borderRadius={0}
            color="rgba(255, 255, 255, 0.7)"
            colorScheme="whiteAlpha"
            onClick={onCancel}
          >
            {cancelText}
          </Button>
          <Box
            background="rgba(255, 255, 255, 0.1)"
            height="100%"
            width="1px"
          />

          <Button
            flex={1}
            variant="ghost"
            height="100%"
            borderRadius={0}
            color="rgba(14, 201, 252, 0.83)"
            colorScheme="whiteAlpha"
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  ) : (
    <></>
  )
}
